module.exports = __webpack_public_path__ + "img/gi.e829d66.svg";